import React, { useState } from "react";
import "../styles/Pyramidhelppanel.css";

interface HelppanelProps {
  isOpenPanel: boolean;
  setisOpenPanel: (value: boolean) => void;
}

const Helppanel: React.FC<HelppanelProps> = ({
  isOpenPanel,
  setisOpenPanel,
}) => {
  const [showhelpPivots, setShowhelpPivtots] = useState<string>("pivotTask");

  return (
    <div className="P-helpPanel" id="P-helpPanel" hidden={!isOpenPanel}>
      <img
        src="/img/close.svg"
        id="P-closeButton"
        alt="Закрыть"
        className="P-closeButton"
        onClick={() => setisOpenPanel(false)}
      />
      <div className="P-helpPivots">
        <div
          className="P-selectPivots"
          id={showhelpPivots === "pivotTask" ? "P-activePivot" : ""}
          onClick={() => setShowhelpPivtots("pivotTask")}
        >
          Задача
        </div>
        <div
          className="P-selectPivots"
          id={showhelpPivots === "pivotModes" ? "P-activePivot" : ""}
          onClick={() => setShowhelpPivtots("pivotModes")}
        >
          Режимы
        </div>
        <div
          className="P-selectPivots"
          id={showhelpPivots === "pivotButtons" ? "P-activePivot" : ""}
          onClick={() => setShowhelpPivtots("pivotButtons")}
        >
          Кнопки
        </div>
        <div
          className="P-selectPivots"
          id={showhelpPivots === "pivotCommands" ? "P-activePivot" : ""}
          onClick={() => setShowhelpPivtots("pivotCommands")}
        >
          Команды
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="P-commandsCards">
          <div className="P-helpCard">
            <div className="P-cardCaption">Суть игры</div>
            <div>
              <div> Переместить пирамиду с площадки А на площадку С.</div>
            </div>
            <br />
            <div className="P-cardCaption">Правила игры</div>
            <div>
              <div>
                {" "}
                1. Пирамида собрана на площадке А. Внизу стоит самый большой
                артист, а наверху — самый маленький. <br />
                2. Можно перемещать с одной площадки на другую только верхнего артиста. <br />
                3. Больший артист не может вставать на меньшего.
              </div>
            </div>
          </div>
        </div>
      )}
      {showhelpPivots === "pivotModes" && (
        <div id="P-modesCards">
          <div className="P-helpCard">
            <div className="P-cardCaption">
              <img
                src="/img/button/control_2.svg"
                className="P-iconhelp"
                alt="знакомство"
              />{" "}
              Знакомство
            </div>{" "}
            <div>
              {" "}
              Ты можешь изучить команды Котобота. Нажимай на кнопки над полем
              кода. И твои действия сразу отобразятся на поле Котобота, без
              написания программы. В этом режиме нельзя ввести код программы,
              поле ввода заблокировано.
            </div>
          </div>
          <div className="P-helpCard">
            <div className="P-cardCaption">
              <img
                src="/img/button/edit_2.svg"
                className="P-iconhelp"
                alt="программирование"
              />{" "}
              Программирование
            </div>{" "}
            <div>
              {" "}
              Код программы надо писать в поле ввода кода. Для этого используй
              команды Котобота. Команды можно писать самому, а можно ускорить
              процесс с помощью кнопок над полем кода. Они вводят кодовые слова
              целиком.
            </div>
          </div>
          <div className="P-helpCard">
            <div className="P-cardCaption">
              <img
                src="/img/button/run_2.svg"
                className="P-iconhelp"
                alt="запуск"
              />{" "}
              Запуск
            </div>{" "}
            <div>
              {" "}
              Хочешь увидеть, что делает твоя программа? Запускай, и Котобот
              выполнит её! Если программа уже дописана и она решает задачу,
              Котобот поздравит тебя. Если в программе есть ошибка, ты увидишь
              сообщение о ней. А если программа не дописана, ты увидишь, что уже
              сделано и что ещё осталось дописать.
            </div>
          </div>
          <div className="P-helpCard">
            <div className="P-cardCaption">
              <img
                src="/img/button/debug_2.svg"
                className="P-iconhelp"
                alt="отладка"
              />{" "}
              Отладка
            </div>{" "}
            <div>
              {" "}
              Нужно понять, как работает твой алгоритм? Активируйте отладку! Он
              позволяет исполнить программу пошагово, наблюдая за действиями в
              реальном времени. Ты сможете локализовать ошибку, проверить логику
              условий и циклов, и увидеть точный путь выполнения вашего кода.
            </div>
          </div>
        </div>
      )}
      {showhelpPivots === "pivotButtons" && (
        <div id="P-buttonsCardsEdit">
          <div className="P-helpCard">
            <div className="P-cardCaption">
              <div className="P-auxButtonshelp">
                <img src="/img/button/AB.svg" className="P-icon-transButtons-help" alt="AtoB" />
                <img src="/img/button/BA.svg" className="P-icon-transButtons-help" alt="BtoA" />
                <img src="/img/button/CA.svg" className="P-icon-transButtons-help" alt="CtoA" />
                <img src="/img/button/AC.svg" className="P-icon-transButtons-help" alt="AtoC" />
                <img src="/img/button/BC.svg" className="P-icon-transButtons-help" alt="BtoC" />
                <img src="/img/button/CB.svg" className="P-icon-transButtons-help" alt="CtoB" />
              </div>
            </div>
            <div>
              Добавляют команды перемещения артиста с одной площадки на другую.
            </div>
          </div>
        </div>
      )}
      {showhelpPivots === "pivotCommands" && (
        <div id="P-commandsCards">
          <div className="P-helpCard">
            <div className="P-cardCaption">Перемещения</div>
            <div>
              <div className="P-code">
                <b>move ( X , Y )
                </b> <br />
                Перемещение артиста с площадки <b>X</b> на площадку <b>Y</b>.
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Helppanel;
